import mutations from './mutations'
import apiMenues from '@/services/api/Menues'

const setMenues = function({ commit }, payload) {
    commit('SET_MENUES', payload)
}

const setShowSubmenues = function({commit}, index){
    commit('SET_SHOW_SUBMENUES', index)
}

const setTitleTopBar = function({commit}, newTitle){
    commit('SET_TITLE_TOP_BAR', newTitle)
}

const resetState = function({ commit }) {
    commit('RESET')
}

const fetchMenues = async function({dispatch }, moduleId) {
    let arrayMenues
    let response = await apiMenues.getMenues(moduleId)
    if(response.status === "success"){
        arrayMenues = response.data.g_menu_module_user
    }else{
        arrayMenues = [ {id:1, name: "No puede acceder a ninguna opción", icon:"error", route:'/', g_submenus: null}]
    }
    dispatch('setMenues', arrayMenues)
    //console.log(arrayMenues)
}

/**
 * 
 */
const setItemsTopBar = ( context, items ) => {
    context.commit( "SET_TOOLBAR_ITEMS", items )
}

export default {
    setMenues,
    resetState,
    fetchMenues,
    setShowSubmenues,
    setItemsTopBar,
    setTitleTopBar
}
